import axios, { AxiosInstance, AxiosPromise, AxiosRequestConfig, Method } from 'axios';
import { IRestClient, IRestClientParams } from './models';

export class RestClient implements IRestClient {
  instance: AxiosInstance;
  private readonly cacheStorage: undefined;
  private readonly config: AxiosRequestConfig;

  constructor(config?: IRestClientParams) {
    this.cacheStorage = undefined;

    this.config = {
      ...config,
    };

    this.instance = axios.create({
      ...this.config,
    });
  }

  private request<Rq, Rs>(method: Method, url: string, data?: Rq) {
    return this.instance({
      data,
      method,
      url,
    }) as AxiosPromise<Rs>;
  }

  /**
   * GET request method.
   *
   * @param {string} url REST path.
   */
  public get<Rs>(url: string) {
    return this.request<undefined, Rs>('get', url);
  }

  /**
   * POST request method.
   *
   * @param {string} url REST path.
   * @param {Rs} data Data for POST request.
   */
  public post<Rq, Rs>(url: string, data: Rq) {
    return this.request<Rq, Rs>('post', url, data);
  }

  /**
   * PUT request method.
   *
   * @param {string} url REST path.
   * @param {Rq} data Data for PUT request.
   */
  public put<Rq, Rs>(url: string, data: Rq) {
    return this.request<Rq, Rs>('put', url, data);
  }

  /**
   * PATCH request method.
   *
   * @param {string} url REST path.
   * @param {Rq} data Data for PATCH request.
   */
  public patch<Rq, Rs>(url: string, data: Rq) {
    return this.request<Rq, Rs>('patch', url, data);
  }

  /**
   * DELETE request method.
   *
   * @param {string} url REST path.
   */
  public delete<Rq, Rs>(url: string) {
    return this.request<Rq, Rs>('delete', url);
  }

  /**
   * Upload POST request method.
   *
   * @param {string} url REST path.
   * @param {Rs} data Data for POST request.
   */
  public upload<Rq, Rs>(url: string, data: Rq) {
    const conf: AxiosRequestConfig = {
      ...this.config,
      headers: { 'Content-Type': 'multipart/form-data' },
      method: 'post',
      data,
      url,
    };

    return this.instance(conf) as AxiosPromise<Rs>;
  }
}
